import React from 'react';
import { number, string } from 'prop-types';

const IconArrowUp = ({ height = 13, width = 14, fill = '#ffffff' }) => {
  return (
    <svg data-test="iconarrowup" width={width} height={height} viewBox="0 0 12 10" fill="none">
      <path
        d="M6.14453 0.349609L11.3407 9.34961H0.948379L6.14453 0.349609Z"
        fill={fill}
      />
    </svg>
  );
};

IconArrowUp.propTypes = {
  height: number,
  width: number,
  fill: string,
};

export default IconArrowUp;
